// 경로: 루트 디렉토리/vue.config.js
"use strict";
const path = require("path");
const ansiRegex = require("ansi-regex");

function resolve(dir) {
  return path.join(__dirname, dir);
}

module.exports = {
  devServer: {
    disableHostCheck: true,
    overlay: false,
    https: true,
    // https: process.env.ENV === "development",
    proxy: {
      "^/lookup": {
        target: process.env.VUE_APP_NICE_API,
        changeOrigin: true,
        secure: false,
        logLevel: "debug",
      },
      "^/auth": {
        target: process.env.VUE_APP_NICE_AUTH_API,
        changeOrigin: true,
        secure: false,
        logLevel: "debug",
      },
      "^/v1": {
        target: process.env.VUE_APP_REVO_API,
        changeOrigin: true,
        secure: false,
        logLevel: "debug",
      },
    },
    host: "localhost",
  },
  configureWebpack: {
    resolve: {
      alias: {
        "@": resolve("src"),
      },
    },
  },
  transpileDependencies: [ansiRegex],
};
